import { useState, useEffect } from "react";
import { Plan } from "../../components/plans/Plan.component";
import Spinner from "../../components/ui/Spinner.component";
import Breadcrumb from "../../components/ui/Breadcrumb.component";
import axios from "axios";

export const SubscriptionPage = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1/sales/subscription/me/`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        setSubscriptionData(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [token]);

  if (!subscriptionData) {
    return (
      <div className="w-screen h-screen">
        <div className="flex relative bg-black/[.27]  h-full">
          <div>
            <Breadcrumb
              segments={["Home", "Subscription"]}
              paths={["/", "/subscription"]}
            />
          </div>
          <div className="absolute top-1/2 left-1/2">
            <Spinner />
          </div>
        </div>
      </div>
    );
  }

  const name = subscriptionData.data.product.name + " Clinic";
  const details = subscriptionData.data.product.details;
  const info = details.split("\r\n").map((item) => item.replace("* ", ""));

  return (
    <div>
      <Breadcrumb
        segments={["Home", "Subscription"]}
        paths={["/", "/subscription"]}
      />
      <Plan
        name={name}
        status={subscriptionData.data.status}
        button
        active
        info={info}
        description={subscriptionData.data.product.description}
      />
      <div className="m-5 my-12 md:m-0 md:ml-[84px] md:my-[56px] px-8 md:px-0">
        <h2 className="text-[22px] font-bold">Cancel subscription</h2>
        <p className="text-base mt-4">
          Do you want to cancel your subscriptions? It will impact on your
          organization’s members
        </p>
        <button className="bg-gr px-7 mt-10 py-2 font-semibold text-base bg-transparent text-[#338CC7] rounded-[12px] border border-[#338CC7]">
          Cancel subscription
        </button>
      </div>
    </div>
  );
};
